import { CoreModule } from "@modules/core/core.module";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { VisionOptinToggleComponent } from "./vision-optin-toggle.component";

@NgModule({
	declarations: [VisionOptinToggleComponent],
	imports: [CoreModule, ReactiveFormsModule],
	exports: [VisionOptinToggleComponent]
})
export class VisionOptinTogglesModule {}
